import Lottie from 'react-lottie-player';
import PendingClock from 'lotties/PendingClock.json';

const ClockPendingLottie = () => {
  const defaultOptions = {
    loop: true,
    play: true,
    animationData: PendingClock,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
    isClickToPauseDisabled: true,
  };

  return (
    <Lottie
      {...defaultOptions}
      style={{ height: 100, width: 100, margin: 'auto' }}
      isClickToPauseDisabled
      speed={0.8}
    />
  );
};

export default ClockPendingLottie;
